import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "desktopHeaderLocation",
  "use": "desktopHeaderLocation-usage",
  "viewBox": "0 0 17 22",
  "content": "<symbol viewBox=\"0 0 17 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"desktopHeaderLocation\"><g fill=\"none\" stroke=\"#9c7446\" stroke-width=\"1.15\" stroke-miterlimit=\"10\"><path d=\"m15.8 7.8c0 4-7.3 12.7-7.3 12.7s-7.3-8.6-7.3-12.7 3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3z\" /><circle cx=\"8.5\" cy=\"8\" r=\"2.8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol